import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=983f3c2e&scoped=true&"
import script from "./TextBlock.vue?vue&type=script&lang=ts&"
export * from "./TextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=983f3c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983f3c2e",
  null
  
)

export default component.exports